import { gql } from '@apollo/client';
import baseImage from '../../../gqlCommon/graphql/fragments/baseImage';
import carPrice from '../../../gqlCommon/graphql/fragments/carPrice';
import price from '../../../gqlCommon/graphql/fragments/price';
import finance from '../../../gqlCommon/graphql/fragments/finance';
import stockCars from '../../../gqlCommon/graphql/fragments/stockCars';
import insurance from '../../../gqlCommon/graphql/fragments/insurance';
import standardFeatures from '../../../gqlCommon/graphql/fragments/standardFeatures';
import engineAttributes from '../../../gqlCommon/graphql/fragments/engineAttributes';

const customizeCar = {
  GET_CUSTOMIZE_CAR: gql`
    ${baseImage.BASE_IMAGE}
    ${carPrice.CAR_PRICE}
    ${price.PRICE}
    ${finance.FINANCE}
    ${stockCars.STOCK_CARS}
    ${insurance.INSURANCE}
    ${standardFeatures.STANDARD_FEATURES}
    ${engineAttributes.ENGINE_ATTRIBUTES}
    query GetCustomizeCar(
      $carId: CarId!
      $selectedFeatureIds: FeatureIdsInput
      $postCode: String
      $financeFormInput: FinanceFormInput
      $financeInput: FinanceInput
      $financeProductId: FinanceProductId
      $needsInteraction: Boolean
      $vehicleConfigurationUrl: String
      $insuranceFormInput: InsuranceFormInput
      $includeReservationFee: Boolean!
      $includeIndicativeDeliveryTimeframe: Boolean!
      $dealerId: String
      $dataLayer: Boolean!
    ) {
      customizeCar(
        carId: $carId
        selectedFeatureIds: $selectedFeatureIds
        postCode: $postCode
        financeProductId: $financeProductId
        financeInput: $financeInput
        needsInteraction: $needsInteraction
        vehicleConfigurationUrl: $vehicleConfigurationUrl
        insuranceFormInput: $insuranceFormInput
        dealerId: $dealerId
      ) {
        additionalGovernmentTaxes {
          money {
            amount
            currency
          }
          name
        }
        disclaimers(financeFormInput: $financeFormInput) {
          value
          needsToBeTranslated
        }
        financeFormInput @client
        selectedFeaturesId @client
        selectedCurrency @client
        selectedSections @client {
          value
          id
        }
        selectedFeaturesInput @client {
          selected
          added
          removed
        }
        images {
          url
          type
        }
        car {
          trim {
            attributes {
              marketingprefix
              label
              generalDisclaimer
              brand
            }
          }
          variant {
            attributes {
              name
              shortName
            }
          }
          code
          byoCode
          attributes {
            externalSku
            vehicleDisplayName
            specDescription
            priceLabel
            hasIndicativePrice
            promotionalLabel1
            promotionalLabel2
            brochureFile
            insurance {
              amount
            }
            learnMoreLink
            isPreOrder
          }
          model {
            attributes {
              label
              shortname
              modelyear @include(if: $dataLayer)
              longdescription @include(if: $dataLayer)
            }
          }
          engine {
            attributes {
              label
              shortname
              motor
              fuelType
              fuelLabel @include(if: $dataLayer)
              transmissionLabel
              transmissionType @include(if: $dataLayer)
              ...EngineAttributes @include(if: $dataLayer)
            }
          }
          specPack {
            attributes {
              label
              shortname
              nviccode
            }
          }
          bodyStyle {
            attributes {
              label
              shortname
              bodyStyleType @include(if: $dataLayer)
              longdescription @include(if: $dataLayer)
              oemcode @include(if: $dataLayer)
            }
          }
          keyFeatures {
            shortname
            attributes {
              disclaimer
              displayorder
            }
          }
          standardFeatures @include(if: $dataLayer) {
            ...StandardFeatures
          }
        }
        selectedFeatures {
          selected
          added
          removed
        }
        prices {
          source
          carPrice {
            ...CarPrice
          }
          totalFeatures {
            ...Price
          }
          totalOfferFeatures {
            ...Price
          }
          totalConfiguration {
            ...Price
          }
          totalPrice {
            ...Price
            taxes {
              money {
                ...Money
              }
              aggregated
              type
              aggregated
              label
            }
          }
          discounts {
            ...Discount
          }
        }
        finance(financeFormInput: $financeFormInput) {
          ...Finance
        }
        insurance(carId: $carId, insuranceFormInput: $insuranceFormInput) {
          ...Insurance
        }
        availableFeatureCategories {
          label
          code
          parentCategoryCode
          attributes {
            categorypurpose
            selectiontype
            displayorder
            displaymode
            displayfeaturename
            displayfeatureprice
            displaylabelofselectedoptiononcategory
            displaycount
            disclaimerindicative
            viewnumberoffeatures
            numberofitemsperrow
            imagePov
          }
        }
        availableFeatures {
          label
          code
          categoryCode
          parentCategoryCode
          shortDescription
          longDescription
          prices {
            ...Price
          }
          images {
            ...BaseImage
          }
          attributes {
            hexColourCode
            extradetails
            serviceIntervals {
              description
              displayOrder
              prices {
                ...Price
              }
            }
            disclaimer
            salespersonViewOnly
            isDefaultItem
          }
        }
        similarStockCars {
          ...StockCars
        }
        stockInfo {
          dms
          vin
          stockType
        }
        stockAvailability
        reservationFee @include(if: $includeReservationFee) {
          refundableState
          price {
            ...Money
          }
        }
        deliveryTimeFrame @include(if: $includeIndicativeDeliveryTimeframe) {
          deliveryTimeFrameLabel
        }
      }
    }
  `,
};

export default customizeCar;
